const MelillaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111871)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#338AF3"
      />
      <path d="M9.56494 21.7402H30.4345V24.3489H9.56494V21.7402Z" fill="#818085" />
      <path
        d="M13.0435 13.9136L19.9999 14.7833L26.9564 13.9136V9.73969L24.1738 11.131L19.9999 6.95703L15.826 11.131L13.0435 9.73969V13.9136Z"
        fill="#FFDA44"
      />
      <path
        d="M11.3046 26.9563H8.6958V22.1737L9.56541 20.8692L8.6958 19.5649V16.5215H11.3046V26.9563Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.3046 26.9563H28.6958V16.5215H31.3046V19.5648L30.4349 20.8911L31.3046 22.1738V26.9563Z"
        fill="#F0F0F0"
      />
      <path d="M8.6958 19.5654H31.3045V22.1741H8.6958V19.5654Z" fill="#ACABB1" />
      <path
        d="M19.9999 30.4347C16.1641 30.4347 13.0435 27.314 13.0435 23.4782V13.9131H26.9565V23.4782C26.9564 27.314 23.8358 30.4347 19.9999 30.4347Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0002 27.8257C17.6027 27.8257 15.6523 25.8752 15.6523 23.4779V16.5215H24.348V23.4779C24.348 25.8752 22.3976 27.8257 20.0002 27.8257Z"
        fill="#0052B4"
      />
      <path d="M13.0435 13.9131H15.6521V16.5218H13.0435V13.9131Z" fill="#D80027" />
      <path d="M24.3477 13.9131H26.9563V16.5218H24.3477V13.9131Z" fill="#D80027" />
      <path d="M24.3477 19.5654H26.9563V22.1741H24.3477V19.5654Z" fill="#D80027" />
      <path d="M13.0435 19.5654H15.6521V22.1741H13.0435V19.5654Z" fill="#D80027" />
      <path d="M18.6958 13.9131H21.3045V16.5218H18.6958V13.9131Z" fill="#D80027" />
      <path
        d="M20.0002 27.8261C19.5458 27.8261 19.1078 27.7558 18.6958 27.626V30.3104C19.1186 30.3911 19.5542 30.4349 20.0002 30.4349C20.4461 30.4349 20.8817 30.3911 21.3046 30.3104V27.626C20.8926 27.7557 20.4546 27.8261 20.0002 27.8261Z"
        fill="#D80027"
      />
      <path
        d="M15.7103 24.1836L13.6284 26.2655C13.9894 27.0873 14.5044 27.8263 15.1373 28.4458L16.9811 26.602C16.3231 25.9663 15.8647 25.1257 15.7103 24.1836Z"
        fill="#D80027"
      />
      <path
        d="M26.3721 26.2664L24.2902 24.1846C24.1357 25.1266 23.6774 25.9671 23.0195 26.6031L24.8633 28.4468C25.4961 27.8272 26.0112 27.0882 26.3721 26.2664Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111871">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MelillaSvg;
